import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";
import { MaskedLines } from "../components/Seo";
import { BtnPrimary, BtnGhost } from "../components/blocks";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found — Softline Nigeria" description="The page you requested could not be found." path="/404" />
      <section className="bg-charcoal noise-bg bg-grid-dark min-h-[80vh] flex items-center" data-testid="not-found-page">
        <div className="shell py-32">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-lime">Error 404</p>
          <MaskedLines
            as="h1"
            lines={["This page doesn't", "exist — yet."]}
            className="font-display font-bold tracking-tight text-white text-4xl sm:text-6xl leading-[1.03] mt-6"
          />
          <p className="mt-6 max-w-xl text-softgrey leading-relaxed">
            The link may be outdated or the address mistyped. Try the search below, or start from the beginning.
          </p>
          <div className="mt-9 flex flex-wrap gap-4">
            <BtnPrimary to="/" testid="not-found-home-btn">Back to Homepage</BtnPrimary>
            <BtnGhost to="/search" testid="not-found-search-btn">Search the site</BtnGhost>
          </div>
        </div>
      </section>
    </>
  );
}
